// removed by extract-text-webpack-plugin
module.exports = {"root":"_39_6uPnr-ejmiAJr-9HfTT","wrapper":"_3dwpSf4eBce5wNc1Z8Uq3l","spinner":"eeBB3IbvLfVLUNrezcML5","loading":"_3rz1T82V4_acb8W7DcrEY4","block":"TS3Anys8gp7wn74OBLaA6","center":"_1DWilVaIjPaN9JxsvhaoYh","fullPage":"_1OHT3KsROV_UgAlA-Y3PjY","muhimma":"_3jM2piZEXFTjSERQ0UKk3k"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/spinner.scss
// module id = 1198
// module chunks = 0